import styled from 'styled-components'
import Form from '../UI/Form/Form'

export const StyledPasswordLost = styled(Form)``
export const Headline = styled.div`
  font-size: ${({ theme }) => theme.size.lg};
  text-align: center;
  margin-top: 50px;
`
